import { css } from 'react-emotion'

export const colors = {
  background: '#FFFFFF',
  primary: '#FF6639',
  text: '#000000',
  subtext: '#545454',
  foreground: '#E1DADA',
  lightGray: '#F4F4F4',
  secondary: '#3232cc',
  darkBlue: '#3232cc',
  darkGray: '#212224',
  widgetGray: '#3E3E3E',
  illustrationLightBlue: '#E0F0F7',
  illustrationMarl: '#F4F4F4',
  illustrationStroke: '#979797',
  illustrationOrange: '#FFE4D8',
}

export const radii = {
  outer: '14px',
  inner: '8px',
  browser: '8px',
  circle: '100%',
}

export const text = {
  paragraph: '1.4rem',
  subtext: '1rem',
  subtitle: '2rem',
  title: '3rem',
  hero: '6rem',
}

export const patterns = {
  dots: css`
    overflow: hidden;
    position: relative;
    &:after {
      background-image: url('/circle.jpg');
      background-repeat: center;
      background-size: 50px 50px;
      content: '';
      top: -100%;
      left: -100%;
      position: absolute;
      width: 400%;
      height: 400%;
      z-index: 0;
      transform: rotate(45deg);
    }
    & > * {
      position: relative;
      z-index: 1;
    }
  `,
  tightDots: css`
    background-image: url('/bigDot.jpg');
    background-repeat: center;
    background-size: 15px 15px;
  `,
  grid: css`
    background-image: url(https://a.slack-edge.com/275e7/marketing/img/enterprise/hero_bg@2x.png);
    background-size: 1325px 1091px;
    background-position: top center;
    background-repeat: repeat-x;
    background-color: #212224;
  `,
}
export const contentMaxWidth = 1200
export const layouts = {
  content: css`
    margin: 0 auto;
    max-width: ${contentMaxWidth}px;
    padding: 40px;
  `,
}

export const spacing = {
  medium: '0.5rem',
  large: '1rem',

  s: '12px',
  m: '20px',
  l: '28px',
}

export const shadows = {
  button: css`
    box-shadow: 0px 15px 30px 1px rgba(0, 0, 0, 0.25);
  `,
}

export const transforms = {
  right: css`
    transform-style: preserve-3d;
    transform-origin: right;
    transform: scale3d(1.5, 1.2, 1) perspective(1000px) rotateY(-33deg);
  `,
  left: css`
    transform-style: preserve-3d;
    transform-origin: left;
    transform: scale3d(1.5, 1.2, 1) perspective(1000px) rotateY(33deg);
  `,
}

export const timingFuncs = {
  ease: 'cubic-bezier(.53,.14,.27,.99)',
}

export const mobile = styles => css`
  @media only screen and (max-width: 800px) {
    ${styles};
  }
`
export const desktop = styles => css`
  @media only screen and (min-width: 800px) {
    ${styles};
  }
`

export default {
  spacing,
  patterns,
  radii,
  text,
  colors,
  layouts,
  shadows,
  timingFuncs,
  transforms,
  mobile,
  desktop,
}



// WEBPACK FOOTER //
// ../styleguide/src/styleguide.js